import { checkboxStyles } from './checkbox.styles';
import { checkIcon, minusIcon } from '../../styles/icons';
import { checkboxTemplate } from './checkbox.template';
import { FASTElement, observable, SyntheticViewTemplate } from '@microsoft/fast-element';
import { CheckableFormAssociated } from '../../foundation/form-associated';
import { keySpace } from '@microsoft/fast-web-utilities';
import { NatGenDesignSystem } from '../../natgen-design-system';

class _Checkbox extends FASTElement {}
interface _Checkbox extends CheckableFormAssociated {}

/**
 * A form-associated base class for the {@link @microsoft/fast-foundation#(Checkbox:class)} component.
 *
 * @beta
 */
export class FormAssociatedCheckbox extends CheckableFormAssociated(_Checkbox) {
    proxy = document.createElement("input");
}


// TODO: New generic options pattern
export declare type CheckboxOptions = {
    checkedIndicator?: string | SyntheticViewTemplate;
    indeterminateIndicator?: string | SyntheticViewTemplate;
};

/**
 * @element natgen-checkbox
 */
export class NatGenCheckbox extends FormAssociatedCheckbox {
     /**
     * The element's value to be included in form submission when checked.
     * Default to "on" to reach parity with input[type="checkbox"]
     *
     * @internal
     */
    public initialValue: string = "on";

    /**
     * @internal
     */
    @observable
    public defaultSlottedNodes: Node[];

    /**
     * The indeterminate state of the control
     */
    @observable
    public indeterminate: boolean = false;

    constructor() {
        super();

        this.proxy.setAttribute("type", "checkbox");
    }

    private toggleChecked() {
        if (this.indeterminate) {
            this.indeterminate = false;
        }
        this.checked = !this.checked;
    }

    /**
     * @internal
     */
    public keypressHandler = (e: KeyboardEvent): void => {
        if (this.disabled) {
            return;
        }

        switch (e.key) {
            case keySpace:
                this.toggleChecked();
                break;
        }
    };

    /**
     * @internal
     */
    public clickHandler = (e: MouseEvent): void => {
        if (!this.disabled) {
            this.toggleChecked();
        }
    };
}

export const natGenCheckboxDefinition = NatGenCheckbox.compose({
    name: `${NatGenDesignSystem.prefix}-checkbox`,
    template: checkboxTemplate({
        checkedIndicator: checkIcon,
        indeterminateIndicator: minusIcon
    }),
    styles: checkboxStyles
});
